import { useTranslation } from 'react-i18next';
import PageHeader from '@/ui/organisms/PageHeader';

const FAQ_KEYS = ['wallet', 'price', 'noPayment', 'ironSilent'] as const;

export default function FAQ() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-prose px-8 py-12" data-testid="faq-root">
      <PageHeader eyebrow={t('faq.eyebrow')} title={t('faq.title')} />
      <div className="space-y-3">
        {FAQ_KEYS.map((key) => (
          <details
            key={key}
            className="rounded border border-hairline bg-paper p-5"
            data-testid={`faq-item-${key}`}
          >
            <summary className="cursor-pointer text-base font-medium text-ink">
              {t(`faq.items.${key}.q`)}
            </summary>
            <p className="mt-3 text-sm leading-relaxed text-ink-2">
              {t(`faq.items.${key}.a`)}
            </p>
          </details>
        ))}
      </div>
    </div>
  );
}
